import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { Lock } from '@phosphor-icons/react'

const ToolbarMenu = ({ routes = [] }) => {
  return (
    <nav className="rewards-toolbar-menu">
      <ul>
        {routes.map(
          ({ name, path, hidden, lock }) =>
            !hidden && (
              <li key={name}>
                <NavLink
                  to={path}
                  className={({ isActive }) => (isActive ? 'is-active' : 'is-not')}
                >
                  <span>
                    {lock && <Lock size={18} style={{ position: 'relative', top: 3 }} />} {name}
                  </span>
                </NavLink>
              </li>
            ),
        )}
      </ul>
    </nav>
  )
}

ToolbarMenu.propTypes = {
  routes: PropTypes.array,
}

export default ToolbarMenu
